import * as React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { ModalDialogWithClose } from "main/javascripts/components/modal/ModalDialogWithClose";
import { Button } from "main/javascripts/components/button/Button";
import { borderColor } from "main/javascripts/styles/base/colorStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import { Cruise } from "main/javascripts/types/cruise";
import { CruiseRouteListModalBlock } from "./CruiseRouteListModalBlock";

export interface IProps {
  displayed: boolean;
  uniqueId: string;
  cruiseRoutes: Cruise.CruiseRoute[];
  departureDate?: string;
  cabinCode?: string;
  closeHandler: any;
  enableDynamicMap?: boolean;
  isEventTracking?: boolean;
}

export const CruiseRouteListModalDialog: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const {
    displayed,
    uniqueId,
    cruiseRoutes,
    departureDate,
    cabinCode,
    closeHandler,
    enableDynamicMap,
    isEventTracking,
  } = props;
  const { t } = useTranslation(["button", "component"]);

  if (!uniqueId) {
    return null;
  }

  return (
    <ModalDialogWithClose
      displayed={displayed}
      closeHandler={closeHandler}
      maxWidthStyle="80rem"
      maxHeightStyle="90%"
    >
      <div css={innerStyle}>
        <div css={contentStyle}>
          <CruiseRouteListModalBlock
            uniqueId={uniqueId}
            cruiseRoutes={cruiseRoutes}
            departureDate={departureDate}
            cabinCode={cabinCode}
            enableDynamicMap={enableDynamicMap}
            isEventTracking={isEventTracking}
          />
        </div>
        <div css={buttonBlockStyle}>
          <Button onClick={closeHandler} styleKey="buttonSmallSecondary">
            {t("common.dismiss")}
          </Button>
        </div>
      </div>
    </ModalDialogWithClose>
  );
};

const innerStyle = css`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const contentStyle = css`
  flex: 1;
  padding: ${space.atom3x} ${space.atom2x};
  overflow-y: auto;
  border-top: 1px solid ${borderColor.secondaryLightColor};
  ${moreThanBreakpoint("tablet")} {
    padding: ${space.atom3x} ${space.atom3x};
  }
`;
const buttonBlockStyle = css`
  padding: ${space.atom2x} ${space.atom2x} 0;
  border-top: 1px solid ${borderColor.secondaryLightColor};
  button {
    width: 100%;
    margin-bottom: ${space.atom2x};
  }
  ${moreThanBreakpoint("tablet")} {
    display: flex;
    justify-content: flex-end;
    padding: ${space.atom2x};
    button {
      width: calc(50% - ${space.atom});
      max-width: 20rem;
      margin-bottom: 0;
    }
  }
`;
